import { Card } from "@/components/ui/card";
import mobileFloorStoreLogo from "@/assets/the-mobile-floor-store-logo.webp";
import hugoSilva from "@/assets/hugo-silva.webp";
import {
  Attribution,
  CountUp,
  QuoteCard,
  VideoThumbOverlay,
  useInViewRef,
} from "./testimonial/shared";
import { PerformanceVisual } from "./testimonial/PerformanceVisual";

export function TestimonialFeatureSectionThree() {
  const { ref, inView } = useInViewRef<HTMLElement>();

  return (
    <section ref={ref} className="bg-background pt-16 pb-12 sm:pt-24 sm:pb-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          {/* Left on mobile, right on desktop: headline + quote + attribution */}
          <div className="flex flex-col lg:order-2">
            <div className="flex w-full flex-row items-center justify-between gap-4 pr-8 sm:w-auto sm:items-baseline sm:justify-start sm:gap-6 sm:pr-0">
              <h2 className="min-w-0 text-[2rem] font-bold leading-[1.08] tracking-tight text-foreground sm:text-4xl sm:-translate-y-[10px] lg:text-[2rem] xl:text-4xl">
                <span className="sm:hidden">
                  Monthly leads<br />
                  <span className="whitespace-nowrap">increased by</span>
                </span>
                <span className="hidden sm:inline lg:whitespace-nowrap">Monthly leads increased by</span>
              </h2>
              <span className="text-gradient-cycle shrink-0 text-6xl font-bold tabular-nums sm:text-7xl lg:text-8xl">
                <CountUp target={5} start={inView} suffix="x" />
              </span>
            </div>

            <QuoteCard>
              The new site looks far more professional, and we started getting{" "}
              <span className="text-gradient-cycle font-bold">
                more quote requests
              </span>{" "}
              from the right type of homeowners.
            </QuoteCard>

            <Attribution
              avatarSrc={hugoSilva}
              avatarAlt="Hugo Silva"
              name="Hugo Silva"
              role="Owner, The Mobile Floor Store"
              logoSrc={mobileFloorStoreLogo}
              logoAlt="The Mobile Floor Store logo"
              logoClassName="h-12 shrink-0"
              nameNoWrap
            />
          </div>

          {/* Right on mobile, left on desktop: Performance card with video thumbnail overlay */}
          <Card className="relative mx-auto w-full border-border/60 bg-card/60 p-0 backdrop-blur lg:order-1">
            <div className="relative w-full">
              <PerformanceVisual />
              {/* VideoThumbOverlay removed until video is provided */}
            </div>
          </Card>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-6 pt-12 sm:pt-16 lg:px-10">
        <div className="h-px w-full bg-gradient-to-r from-transparent via-foreground/15 to-transparent" />
      </div>
    </section>
  );
}
